import styled from "styled-components";
import { colorTheme, textTheme } from "../../../../theme";

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
`;

export const Section = styled.div`
  position: relative;
  display: flex;
  flex-direction: row;
  gap: 20px;
`;

export const CheckListContainer = styled.div`
  margin: 20px 0px 40px 0px;
`;

export const Header = styled.div`
  color: ${colorTheme.black};
  ${textTheme.h3};
`;

export const TopSaveWrapper = styled.div`
  position: absolute;
  top: 0;
  right: 0;
`;
